export const TERMS_AND_CONDITIONS = {
  blocks: [
    {
      key: '52c04',
      text: 'Please read the terms & conditions mentioned hereunder carefully before availing or registering for any of the JPSL services/availing Payment Mechanism services. By signing the Merchant Acquisition Form, and/or by digitally accepting these terms and conditions, and/or through any other method as may be introduced by JPSL on the Merchant Partner Platform for accepting these terms & conditions, and/or by using/availing the Payment Mechanism and/or by downloading/accessing/using the Platform, the Merchant Partner agrees to these terms and conditions and shall be bound by the same. The acceptance of these terms and conditions shall be unconditional and without any limitation or qualification.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'di78q', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '13sur',
      text: 'The Payment Mechanism shall be made available to the Merchant Partner at the sole discretion of JPSL. The Merchant Partner unconditionally confirms that the Merchant Partner shall comply with and be bound by these terms and conditions as in force from time to time. No act, delay or omission by JPSL shall affect its rights, powers and remedies under these terms and conditions.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bk3a3',
      text: 'JPSL and Merchant Partner are individually referred to as a “Party” and collectively as the “Parties”.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '695m0', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'bcjpk',
      text: 'NOW, THEREFORE THIS DEED WITNESSETH AS UNDER:',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '5s7eg', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'f4h6d',
      text: 'DEFINITION OF TERMS AND INTERPRETATION',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 38, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '583a4',
      text: 'In the Agreement, (i) capitalised terms defined by inclusion in quotations and/or parenthesis have the meanings so ascribed; and (ii) the following terms shall have the meanings assigned to them herein below:',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6hm9h',
      text: '“Agreement” shall mean these terms and conditions;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bed0v',
      text: '“Acquiring Bank” or “Acquirer” shall mean banks, financial institutions, payment networks and payment system providers licensed under the Payments and Settlement Systems Act 2007 to acquire, authorise and authenticate the online payment transaction;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '86kks',
      text: '“Applicable Law” or “applicable law” shall mean the applicable laws and regulations of India which is including but not limited to rules, guidelines, regulations, notifications and instructions issued by Reserve Bank of India (“RBI”) and/or NPCI and/or any other applicable legal/regulatory authority;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '44ecc',
      text: '“Consumer” shall mean consumer who holds the valid Payment Instrument and makes payment for purchasing the Products from the Merchant Partner utilising the Payment Instrument using the Payment Mechanism through the Merchant Partner Platform;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4fapl',
      text: '“Grievance Redressal Policy” shall mean such dispute resolution mechanism which may be notified by JPSL to the Merchant Partner from time to time;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'athq3',
      text: '“EMI” shall mean monthly instalment payment plan provided by the Payment Service provider to the Consumer;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4ji0b',
      text: '“Escrow Account” shall mean the escrow account maintained by JPSL with a scheduled commercial bank in accordance with the Payment and Settlement System Act, 2007 and the guidelines issued thereunder;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [{ offset: 1, length: 14, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '61rkd',
      text: '“Merchant Partner Account” shall be the account maintained by JPSL at its end to enable JPSL to accept and/or settle payments received from the Consumer;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3uec6',
      text: '“Merchant Partner Application Form”/“MAF” shall mean the form to be completed by the Merchant Partner and submitted along with necessary supporting documents, either online on Platform or physically to designated and authorized agents of JPSL;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'd491j',
      text: '“Merchant Partner Platform” shall mean all platforms declared by the Merchant Partner on which the Consumer makes payment using the Payment Instrument through the Payment Mechanism to the Merchant Partner for purchasing the Products from the Merchant Partner which is including but not limited to : (i) Merchant Partner’s website, (ii) retail outlets/physical stores of Merchant Partner (through POS or otherwise); (iii) Merchant Partner’s mobile application; and (iv) servers/backend servers/websites of a Merchant Partner used for authentication of Transactions undertaken through Platform or any payment instruments processed by JPSL for payment to such Merchant Partner (v) any other platform designated by Merchant Partner and approved by JPSL;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5vk75',
      text: '“Platform” or “JPSL Platform” shall mean www.jiopay.in and includes the corresponding website, mobile app, and/or any other platform of JPSL including website, mobile app and any other platform designated by JPSL;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1lm3c',
      text: '“Payment Mechanism” shall mean the processing and facilitation of online payments by JPSL with the help of the services of Payment Service Providers through the internet utilising the internet banking facility, payment gateway, electronic commerce, and through other modes and methods approved and intimated by JPSL from time to time;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '89fn7',
      text: '”Payment Service Provider” shall mean and include any payment gateways, Acquiring Banks, Financial Institutions, card schemes, issuing bank/institution, payment instrument provider, software providers, food card/meal card providers, collection agents/EMI scheme providers as well as third party service provider that participate in authorisation/authentication/facilitation of the online payments. These Payment Service Providers allow JPSL to use the internet payment gateways/payment facility developed by them to process all type of payment instruments and transactions initiated by the Consumer online on Merchant Partner Platform. The Payment Service Provider shall also include bank and non-banking financial institutes or any other financial company other than Acquiring Banks, card schemes, and payment instrument providers that are authorised to issue a valid Payment Instruments and/or to participate as facilitator of an online transaction;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b3stc',
      text: '“Payment Bank” or “Bank” shall mean Jio Payments Bank Ltd;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cpen7',
      text: '“Payment Instruments” shall mean valid payment instruments issued by the Payment Service Provider which enables the Consumer to initiate and complete the transaction to purchase/avail Products of the Merchant Partner;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9u13p',
      text: '“Point of Sale device” or “POS” means a secure device with an alphanumeric keyboard and through which the Consumer can enter their PIN/swipe/use pre-paid instrument, cards and other approved mode/Payment Instruments and make payments;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cc3hh',
      text: '“Products” shall mean the products and/or services of Merchant Partner purchased/availed by the Consumer and the payment for which is made by the Consumer using the Payment Instrument through the Payment Mechanism on the Merchant Partner Platform;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5r9u',
      text: '“JPSL” shall mean Jio Payment Solutions Limited (formerly known as Reliance Payment Solutions Limited), a company incorporated under the laws of India and having its registered office at 5th Floor, Court House, Lokmanya Tilak Marg, Dhobi Talao, Mumbai – 400 002;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6i2vd',
      text: '“JPSL Polices” shall mean all policies of JPSL, including Merchant Onboarding and KYC-AML Policy, Merchant Settlement & Reconciliation Process, Grievance Redressal Policy, Privacy Policy, etc. published on the Platform (www.jiopay.in) and/or communicated to the Merchant Partner from time to time;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 220, length: 14, key: 0 }],
      data: {},
    },
    {
      key: '8ffc9',
      text: '“Settlement Account” shall mean the settlement account of the Merchant Partner identified in the MAF to which the proceeds of the Transactions processed on behalf of the Merchant Partner are to be credited as per the records of the Merchant Partner Account from the Escrow Account. JPSL may change the settlement account of the Merchant Partner in its records on the request of the Merchant Partner; and',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'brc5v',
      text: '“Transactions” shall mean payment transaction made by the Consumer utilising the Payment Instrument through Payment Mechanism at the Merchant Partner Platform for purchasing/availing the Products.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'brc5t',
      text: '“VoiceBox” means a smart device that will act as a part of the POS machine providing audio transaction updates to the Entity. This device will come with network connectivity through a SIM card and will have a speaker. Once the Consumer makes the payment by scanning the QR code through Merchant Partner Platform, the VoiceBox will notify the Merchant Partner that the payment is completed successfully. Whenever the Merchant Partner accepts the payment by scanning (Static) QR code through POS Machine, the VoiceBox will notify the Merchant Partner that the payment is completed successfully by announcing the amount loudly on a successful transaction;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'brc5w',
      text: '“SIM Card” or “Card” shall mean Subscriber Identification Module Smart Card, for use with the VoiceBox to enable access to the network in order to avail of the services.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bp06s',
      text: 'INTERPRETATION',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '2ps73',
      text: 'The MAF, Schedules, Annexures and any amendments, modification, additions thereto shall form part of this Agreement and shall have the same force and effect. In the event of a conflict between this Agreement and any other JPSL agreements or policies, this Agreement shall prevail. The payment network (i.e. Visa/Mastercard/RuPay//American Express/Discover, etc.) rules, policies, guidelines, regulation etc. shall prevail in case of card payment services.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'bfq7m', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '43h9j',
      text: 'SCOPE OF THE AGREEMENT',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 22, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a25cf',
      text: 'JPSL has agreed to provide and the Merchant Partner has agreed to avail Payment Mechanism services on nonexclusive basis on the terms and conditions of this Agreement.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '52gjb', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'a9fke',
      text: 'MERCHANT PARTNER ACCOUNT REGISTRATION AND OTHER OBLIGATIONS OF MERCHANT PARTNER',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 79, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '5pbe2',
      text: 'JPSL has availed facilities of Payment Service Providers which includes but is not limited to payment gateway services, net banking services, collection services, EMI facility services, net banking facilities, card payments, food/meal card payment services and electronic software distribution services and also provides authorisation and settlement facilities in respect of payments initiated by the Consumers at the Merchant Partner Platform. JPSL is also in the business of bill payment/presentment and accepting the instructions from the Consumers for making payments using the Payment Instruments to the Merchant Partner. The Merchant Partner agrees and understands that JPSL provides payment aggregation and facilitation services to the Merchant Partner for accepting the Payment Instruments from Consumers for completing the transaction of purchasing/availing the Products. The Payment Mechanism of JPSL shall be subject to the RBI regulations/Applicable Laws. JPSL shall also provide the payment gateway services, bill presentment and settlement under Bharat Bill Payment System (BBPS) and/or any other services through the Payment Mechanism as may be approved by JPSL for the Merchant Partner subject to the terms and conditions of this Agreement.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '2kk9i',
      text: 'On receipt of MAF, KYC documents, and other documents as requested by JPSL and on approval of Payment Mechanism by JPSL for the Merchant Partner, JPSL may activate Merchant Partner Account for the Merchant Partner and the same shall be intimated to the Merchant Partner.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '7b6tu',
      text: 'Merchant Partner shall ensure that it shall comply with all orders of the Consumer for the Products of the Merchant Partner, for which the Consumer has used Payment Mechanism for making payment to the Merchant Partner and deliver the Products as per industry standards. Merchant Partner agrees and acknowledges that all risks associated with the sale of the Products/delivery of the Products, quality, merchantability, non-delivery and delay in delivery of the Products shall be solely that of Merchant Partner and JPSL shall have no liability thereof, in any manner whatsoever and Merchant Partner agrees to indemnify and keep JPSL indemnified from the same. The Merchant Partner understands that JPSL reserves the right to undertake background and antecedent checks of the Merchant Partner in order to ensure that such Merchant Partners do not have any malafide intention of duping customers, do not sell fake / counterfeit or prohibited products.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'aaomr',
      text: 'JPSL shall assume that: the request for the Transaction (a) that originates from the Merchant Partner has been duly authorised by Merchant Partner; (b) that originate from the Consumer has been duly authorised by the Consumer. JPSL shall not be liable for any losses or damages caused to any person including the Merchant Partner whatsoever as a result of any such request being unauthorised, inaccurate or fraudulent.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4j2ud',
      text: 'Merchant Partner agrees that JPSL may use Merchant Partner logos, service marks and trade marks on a non-exclusive, royalty free, license for displaying it on any of the marketing material of JPSL in the list of Merchant Partners or as a Merchant Partner of JPSL and the Parties may use the trade marks, or service marks or logos of the other Party jointly after mutual agreement on any joint marketing material approved by the Parties. The Merchant Partner shall not use any logos, name, trademarks, service marks or any intellectual property of JPSL without prior written permission from JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '55lef',
      text: 'The Merchant Partner shall ensure that there is no breach of security at its end and that the integrity of the link between Payment Mechanism and Merchant Partner Platform is maintained at all time. Merchant Partner shall ensure that there are proper encryption and security measures in its systems and Merchant Partner Platform to prevent any hacking into information pertaining to the Transactions and the Consumer under this Agreement.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '23pj4',
      text: 'Merchant Partner shall use the merchant encryption key provided by JPSL for integration and acknowledge the receipt and confidentiality of the said merchant encryption key.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '7kjjs',
      text: 'Merchant Partner shall ensure that it has all necessary infrastructure and facilities at Merchant Partner Platform to provide uninterrupted service to the Consumer.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6ig6k',
      text: 'Merchant Partner shall not request the Consumer for sharing any confidential Consumer details to be used in Transaction by the Consumer which is including but not limited to passwords, card number, account number and PIN in relation to Platform and Payment Mechanism. The Merchant Partner shall not under any circumstances store customer’s payment data. The Merchant Partner may however store limited data (last four digits of actual card number and card issuer’s name) solely for the purpose of transaction tracking/reconciliation under this Agreement; provided such required limited information shall be stored in compliance with adequate standards applicable under the applicable laws.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '48lce',
      text: 'If JPSL and/or Payment Service Provider suspect that Merchant Partner has committed breach of this Agreement, fraud, against JPSL, Payment Service Provider and/or the Consumer, JPSL shall be entitled to suspend all payments under this Agreement to Merchant Partner pending enquiries by JPSL and JPSL shall not liable to pay any interest upon such suspended amounts during or after the pendency of the inquiry.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b6a97',
      text: 'JPSL has or may enter into agreements with third parties like banks, GST application service providers, etc., which may have direct bearing on the Payment Mechanism services to the Merchant Partner and/or be incidental and/or ancillary thereto. There may be terms in such agreements which may be applicable to the Merchant Partner. JPSL shall intimate said terms to the Merchant Partner from time to time vide email or through publication on the Platform. The Merchant Partner shall keep itself updated with the same by visiting the Platform from time to time.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9qbfi',
      text: 'The Merchant Partner agrees that it shall use the Payment Mechanism for the legitimate business disclosed by it under this Agreement. It shall not use the Payment Mechanism for any other business operated in the same Merchant Partner premises. The Merchant Partner shall approach JPSL to enter in to separate Merchant Partner agreement for the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'f5m4',
      text: 'In the event the Merchant Partner avails debit card/ credit card acceptance services from Acquiring Bank(s) notified by JPSL, it shall be bound by the terms and conditions of such Acquiring Bank. The Merchant Partner agrees that any changes to the Acquirer may be made by publishing the details of such Acquirer on the Platform with such additional terms and conditions as may be introduced by such new Acquirer(s).',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6padj',
      text: 'The Merchant Partner shall provide JPSL with the address of each of its offices/Merchant Partner Platform where the Payment Mechanism shall be availed by the Merchant Partner for accepting payments from the Consumer and the complete description of the Products sold by it on ongoing basis as and when requested by JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6rsjk',
      text: 'Merchant Partner agrees and confirms that all the documents provided by the Merchant Partner to JPSL are true copy of its original documents and all information and details provided are true, accurate and complete and it shall indemnify and keep JPSL indemnified from any loss, dispute, cost, compensation, litigation etc. arising out of and related to the same. Merchant Partner shall submit the original documents for verification as and when demanded by JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'tvn2',
      text: 'The Merchant Partner agrees and accepts that all payment network and JPSL trademarks, tradenames, service marks etc. are the respective property of their owners and that Merchant Partner shall not contest such ownership under any circumstances. Merchant Partner agrees that at any point of time JPSL, the acquirer or a payment network or Payment Service Provider may prohibit the Merchant Partner from using any payment network branding/marks.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'd3kcd',
      text: 'Further Merchant Partner shall ensure fair acceptance of all payment network cards/Payment Instruments for transactions by Consumers in accordance with the requirements of the respective payment network and JPSL Policies. Merchant Partner also accepts that a payment network or JPSL may enforce any provision of its respective rules in order to ensure the integrity of its card program and the Merchant Partner agrees to abide by any such decision of the payment network or JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9g0m8',
      text: 'The Merchant Partner explicitly agrees and confirms that JPSL can share the Merchant Partner’s personal information, data and any other documents including KYC documents submitted by the Merchant Partner with JPSL, with any of the JPSL’s group companies and affiliates including the Payments Bank and these documents may be used by such entities to meet their KYC and other compliance requirements in relation to any services provided/to be provided to the Merchant Partner by the said entities under separate agreements (including in connection with opening of any bank account for the Merchant Partner by the Payment Bank Entity).',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8njij',
      text: 'The Merchant Partner hereby acknowledges and agrees that JPSL can share the Merchant Partner’s personal information, data, and other information including KYC information, transaction information etc. with any relevant acquirer and/or point of sale device distributor and/or payment network and/or the Payment Service Provider and/or GST application service providers and/or any other service providers whose services may be availed by the Merchant Partner whether under this Agreement or otherwise (“Other Service Providers”). The Merchant Partner hereby further acknowledges, agrees and consents to JPSL for receiving and/or utilising any and all such information as may be shared between the Merchant Partner and JPSL/Other Service Providers, for the purposes of provision of Payment Mechanism.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'eo62h',
      text: 'For availing the Payment Mechanism, the Merchant Partner hereby expressly consents and agrees to provide all information, documents including personal information & data, know-your-customer or “KYC” documents, merchant identity, address and credit information, transaction information and/or any other information required by JPSL, to JPSL and/or such authorised agent of JPSL, as may be determined by JPSL, from time to time for use, transfer, process, utilise, store etc. the said information for the purpose of this Agreement.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '19gn0',
      text: 'Without prejudice to the foregoing, where such authorised agent of JPSL is the Bank/affiliates/group companies of JPSL, the Merchant Partner hereby expressly consents and agrees to Bank/affiliates/group companies of JPSL sharing with JPSL, all information & documents, transaction information including KYC documents etc. furnished by the Merchant Partner to the Bank/affiliates/group companies of JPSL for availing services and/or JPSL Payment Mechanism or other services.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4lv6v',
      text: 'If the Merchant Partner has signed more than one Merchant Partner agreement with JPSL and has opened more than one Merchant Partner Account for its business, JPSL shall have right to set-of amount from any of the Merchant Partner Account of any of the business of the Merchant Partner for the recovery of the amounts due from Merchant Partner from any of its businesses. Merchant Partner agrees that Merchant Partner shall have no objection on the same and hereby authorize JPSL to set off amount from the Merchant Partner Account at the discretion of JPSL any time.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bjkhb',
      text: 'Any information shared by JPSL and any of JPSL affiliates/group companies/holding/subsidiary companies with the Merchant Partner under this Agreement shall be Confidential Information of JPSL and its respective affiliate/group/holding/subsidiary companies and shall be owned by them. The Merchant Partner shall keep the Confidential Information confidential and shall not share the same with any third party. The Merchant Partner shall return all Confidential Information to JPSL on termination of this Agreement or on demand of JPSL whichever is earlier.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3h0j5',
      text: 'The Merchant Partner agrees not to engage in any prohibited business/activities as may be communicated by JPSL at the time of onboarding. JPSL shall publish amended list of prohibited business/activities from time to time on the Platform and the Merchant Partner shall be bound to comply with the said lists. The Merchant Partner agrees that JPSL may terminate this Agreement any time without notice to the Merchant Partner if JPSL is of the view that the Merchant Partner is involved in any prohibited business/activities.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'dn3se',
      text: 'The Merchant Partner shall comply with applicable laws, applicable Visa, Mastercard and/or Payment Service Providers and/or any other payment network security requirement including those related to transaction information, storage etc. as may be communicated by JPSL from time to time to Merchant Partner.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3i7v0',
      text: 'Merchant Partner understands that the Payment Services are merely facilitated by JPSL by engaging with Payment Service Providers, third party service providers etc. as the case may be to enable extension of Payment Mechanism to the Merchant Partner for accepting payments from the Consumers.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '94oi6',
      text: 'Merchant Partner hereby agrees that the Payment Mechanism/Platform are subject to terms and conditions prescribed by third parties enabling services on the Payment Mechanism including but not limited to terms and conditions of Payment Service Provider etc. The Merchant Partner hereby agrees to bind by such terms and conditions.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'e90p0',
      text: 'Merchant Partner shall not do any act or conduct any activity that could adversely affect the goodwill, reputation and interest of JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4b7hu',
      text: 'All the commercials/contractual terms to the Consumer in relation to Products shall be offered by the Merchant Partner and agreed upon between Merchant Partner and Consumer alone. The Products, commercials/contractual terms include (without limitation) price, shipping cost, mode of delivery, warranty, quality, quantity, after sale services etc. related to the Products. JPSL does not determine, advice have any control or in any way involved itself in the offering or acceptance of such commercials/contractual terms between Merchant Partner and Consumer. JPSL shall not be responsible for any non-performance or breach of any contract between Merchant Partner and its Consumers. The Merchant Partner shall not make JPSL party to any litigation/issues/dispute in between the Merchant Partner and the Consumer in relation to the products/services of Merchant Partner which is including in relation to quality, quantity, delivery, purity of the goods/services etc.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8ad30',
      text: 'The Merchant Partner shall be liable to pay all monies, refund amounts, chargeback amounts etc. immediately to JPSL as and when demanded by JPSL. Additionally, the Merchant Partner agrees that JPSL may set-off such amounts from the amounts received from the Consumer towards purchase of the Products/Services in the Escrow Account.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'iud9',
      text: 'Merchant Partner agrees that it shall be bound by and comply with all Applicable Laws and regulations which is including but not limited the RBI regulations, NPCI rules, regulations, circulars, Payment Service Provider terms and conditions, rules, regulations etc.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'f9ebs',
      text: 'Merchant Partner agrees that JPSL may set off any penalties levied by RBI, NPCI, Payment Service Provider due to any default/fault/breach by the Merchant Partner from any amount payable to the Merchant Partner. Additionally, JPSL may claim such amounts from Merchant Partner and Merchant Partner shall pay such amounts within 5 (five) days from the receipt of such demand from JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6g0uf',
      text: 'JPSL does not make any representation and warranties in relation to the Consumer. Merchant Partner shall independently verify the bonafides of any particular Consumer that Merchant Partner chooses to deal with.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cvcpk',
      text: 'Merchant Partner agrees and acknowledges that JPSL shall have access to information regarding the Consumer obtained from the Merchant Partner and JPSL shall create or generate database in respect of such Consumers which shall be solely owned by JPSL, with JPSL having complete collection, storage, sharing and transfer rights over it. Merchant Partner shall obtain necessary consent for this from the Consumers.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cparq',
      text: 'Merchant Partner shall ensure adequate supervision for the performance of its obligations set out in this Agreement. Any deficiencies in the performance of Merchant Partner obligation under the Agreement shall be rectified immediately when intimated in writing by JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'f3qfa',
      text: 'JPSL shall not be bound by any declaration or undertaking or any agreement given by Merchant Partner to any legal/regulatory authority or to Consumers on its own account.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'avh9s',
      text: 'Merchant Partner understands and acknowledges that JPSL and/or any Payment Service Provider may reject authorization of a Transaction placed by the Consumer, without any liability, for any reason whatsoever including but not limited to risk management, suspicion of fraudulent, illegal or doubtful transaction, selling of banned items by Merchant Partner, use/sale of blacklisted/banned items and breach of applicable laws and JPSL shall in no event be held liable/responsible for the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '43a6q',
      text: 'Merchant Partner agrees that the Payment Service Providers may at its discretion cancel/suspend/hold any transaction/transaction amount of the transaction between Merchant Partner and Consumer. Also the Merchant Partner may be suspended, limits of the transactions may be modified or any particular Payment Service Provider may terminate its services to the Merchant Partner at its own discretion or when the Payment Service Providers are of the view that the Merchant Partner is breaching laws, terms and conditions, technology/software, not maintaining safety and security of its software, selling banned/illegal goods/services etc. In all such scenario, the JPSL shall not be responsible and liable and Merchant Partner shall not raise any issues/disputes/litigation against JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1dk67',
      text: 'The Merchant Partner agrees and confirms that it has obtained necessary consents from the Consumer for sharing the Consumer information with JPSL and Payment Service Providers for its use, storage, transfer, process, disclosure, collection for the purpose of providing the Payment Mechanism and services of Payment Service Providers.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '34bm6',
      text: 'The EMI options/offers are given by the Payment Service Providers and JPSL has no control on it. JPSL is mere facilitator of the said service through the Payment Mechanism and hence JPSL shall not be responsible and liable for any issues and disputes in relation to the EMI which is including but not limited to stop EMI, non-payment of EMI amounts by the Consumer, bouncing of EMI etc. The Merchant Partner shall directly deal with the Consumer and the Payment Service Provider in case of any dispute in relation to the EMI services availed by the Merchant Partner and JPSL shall not be responsible for the same. The Merchant Partner agrees to indemnify and keep JPSL indemnified from any issues, disputes, litigations, claims, cost, damages, losses etc. arising out of and related to the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'f4dhv',
      text: 'In case of payment collection services wherein the Payment Service Provider shall make payment to the Merchant Partner towards Products purchased by the Consumer and later recover it from the Consumer (“Collection”), the Payment Service Provider shall be responsible for collecting the payments from the Consumers for making payments to the Merchant Partner. The Merchant Partner agrees to accept such additional terms and conditions as may be levied by the Payment Service Provider of the collection services. JPSL shall not be responsible and liable for Collection and payment of the said amounts to the Merchant Partner unless received from the Payment Service Provider. The Merchant Partner shall directly deal with the Consumer and the Payment Service Provider for dispute and issues in relation to the same and agrees to indemnify and keep JPSL indemnified from the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '5me0t', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '45tmn',
      text: 'SODEXO MEAL CARD (applicable for only those Merchant Partners who have accepted Sodexo as a payment option)',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 107, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'e467u',
      text: 'The Merchant Partner shall use the Payment Mechanism to accept the payment from Meal Card subject to terms of this Agreement, Applicable Laws and regulations.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '506ut',
      text: 'JPSL shall not be responsible and liable for any transactions, fraudulent transactions, settlement of transactions, settlement of monies, disputes/issues in relation to the Meal Card, transactions made by the Consumer using the Meal Card, disputes/issues in between Consumer and Merchant Partner and/or Consumer and Sodexo and/or Sodexo and Merchant Partner and/or Sodexo, Consumer and Merchant Partner in relation to Meal Card and all Meal card transactions through Payment Mechanism and the Merchant Partner agrees to indemnify and keep JPSL indemnified from any disputes, issues, liabilities, losses, cost, compensation, litigation, costs, etc. arising out of and related to the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '42vlv',
      text: 'The Merchant Partner agrees that it shall be solely liable and responsible for, (a) delivery of the Products to the Consumer, (b) quality/quantity/defects in Products delivered, (c) refund/chargeback/complaints/disputes in relation to the Products, (d) any other issues in relation to the Products. Here the Products means only food products for the purpose of this Clause 4 and the Merchant Partner shall not accept Meal Card for non-food items.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ds8pl',
      text: 'The Merchant Partner agrees and confirms that, (a) it has executed agreement with the Sodexo SVC India Pvt Ltd (“Sodexo”) in relation to the acceptance of Meal Card payment (“Sodexo Agreement”), (b) the Merchant Partner shall be bound by the terms of the Sodexo Agreement in relation to all the Meal Card transaction even when accepting payment from Meal Card, (c) the Sodexo Agreement is in force and effect and the Merchant Partner shall ensure that the Sodexo Agreement shall remain in force and effect during the Term of this Agreement, (d) it shall be sole responsibility and liability of the Sodexo to settle all the Meal Card transaction payments to the Merchant Partner directly and JPSL shall not be responsible for the same, (e) it shall be sole liability and responsibility of the Merchant Partner to deal with any chargeback/refunds/fraudulent transactions and refund the amounts to the Consumer/Sodexo as per the terms of the Sodexo Agreement and JPSL shall not be responsible and liable for the same, (f) The Merchant Partner shall comply with all applicable laws and regulation in relation to the Meal Card, payments received through Meal Card and Products delivered to the Consumer against the payment received through the Meal Card, (g) the Merchant Partner shall sell only meal products as may be allowed by Sodexo and subject to applicable law to the Consumer. The Merchant Partner agrees to indemnify and keep JPSL indemnified from any disputes, liabilities, losses, litigation, cost, compensation etc. arising out of and related to breach of this Clause.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '4ih37', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '57b01',
      text: 'BANK ACCOUNT CREDENTIALS CONFIRMATION',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 37, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'dgo2s',
      text: 'The Merchant Partner agrees and confirm that, (a) the bank account/Settlement Account details provided by Merchant Partner to JPSL shall be correct and JPSL shall not be responsible for verifying the same, (b) JPSL may make transaction of Rs. 1/- (Rs. One only) or any other denomination at its discretion in the Merchant Partner bank/Settlement Account as may be communicated by the Merchant Partner to JPSL before initiating any settlement in the said Settlement Account/bank account to verify if the credentials of the Merchant Partner are matching with the said bank/Settlement Account, (c) the Merchant Partner has authorised the bank with whom it holds Settlement Account to share its Settlement Account details including Merchant Partner name, account details etc. to JPSL after receipt of the verification transaction amount as mentioned in this clause for verification of the Settlement Account. Notwithstanding anything stated in this Clause, the Merchant Partner shall be solely liable and responsible in case of any liability, disputes, litigations, losses, issues, costs, compensation, damages, etc. arising out of and related to verification of the bank/Settlement Account and settlement of any amount made by JPSL in the said bank/Settlement Account. The Merchant Partner agrees that JPSL may use any other method as well for verification of the Merchant Partner bank/Settlement Account at its discretion and the Merchant Partner shall submit necessary information and documents as may be requested by JPSL with JPSL.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'epr8q', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '7dnc1',
      text: 'UPI RELATED TERMS',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 17, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '5kj09',
      text: 'The Merchant Partner agrees to the following terms and conditions for availing UPI related services –',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5ds6m',
      text: 'The Merchant Partner shall provide all necessary and correct details including account number, amount details for the transaction.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bfc0t',
      text: 'The Merchant Partner agrees and understands that JPSL is providing UPI service in association with the Payments Bank in accordance with UPI guidelines, circular and/or regulations issued by National Payments Corporation of India (“NPCI”) and/or Reserve Bank of India (“RBI”) from time to time (“UPI Services”). The Merchant Partner agrees that the UPI is payment platform developed by NPCI.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1073n',
      text: 'The Merchant Partner agrees that there shall be transaction limit on each UPI transaction as published by JPSL on its Platform or the limit prescribed by the Payments Bank. The Merchant Partner agrees that the Payments Bank may charge fees for the UPI transaction and it shall get in touch with the Payments Bank for any details in relation to the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cmcje',
      text: 'The Merchant Partner shall be bound by the Payments Bank consumer terms and conditions published at https://www.jiopaymentsbank.com/docs/t&c_languages/t-n-c-jul21/jpb-terms-and-conditions-020721.pdf. The Merchant Partner shall visit the Payments Bank website from time to time and keep itself updated with the said terms and conditions including any amendments/modifications thereto. The Merchant Partner agrees that UPI ID shall be issued by the Payments Bank and by using the UPI Services, the Merchant Partner agree with the Payments Bank terms and conditions.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 100, length: 98, key: 1 }],
      data: {},
    },
    {
      key: 'bco3v',
      text: 'The Merchant Partner agrees that JPSL or the payments Bank may at its sole discretion temporarily or permanently suspend Merchant Partners access to the UPI Services if JPSL or Payments Bank believes that there is suspicious or unusual activity being carried out through Merchant Partner’s UPI ID and UPI PIN. Also Merchant Partner agrees that JPSL or Payments Bank may reject UPI transaction for any reason including but not limited to risk management, fraud, suspicious transactions, unlawful transactions and/or violations of applicable law or JPSL Policies.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1h766',
      text: 'The Merchant Partner agrees that JPSL is mere facilitator for UPI Services and cannot control any transactions made using UPI Services.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '63il2',
      text: 'JPSL will endeavour to process UPI transactions in a timely manner, however there may be a delay in processing of UPI transaction due to issues which are beyond its control.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'fh8tv',
      text: 'The Merchant Partner agrees that the data share shall be subject to JPSL Policies and JPSL may share the information with Payments Bank so that Merchant Partner may receive UPI Services. Any data shared by Merchant Partner with JPSL and/or Payments Bank shall be subject to privacy policy of Payments Bank and JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3ocan',
      text: 'The Payments Bank and JPSL may terminate or suspend the use of the UPI Services by Merchant Partner at any time without giving any notice and without liability.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8cv02',
      text: 'JPSL shall act upon instruction for transfer of funds using the UPI system only upon receipt of the complete information required for initiating such transfer of funds for giving effect to the instructions. The transaction shall be initiated by the JPSL on the date of the instruction as per the NPCI clearing timings. The transaction may be rejected or cancelled in case the instructions and/or any information provided by the Merchant Partner does not meet the security procedures of the JPSL and/or the Jio Payments Bank/NPCI/RBI/beneficiary bank. The Merchant Partner also understand that the transaction may also be cancelled/rejected due to any of the reasons like the designated account of the beneficiary not being maintained by the beneficiary bank, an attachment order having been passed in respect of the designated beneficiary account by the competent authority/court, in case of any of the details pertaining to the beneficiary/beneficiary account details recorded with the beneficiary bank or branch not being part of the clearing system or any other reasons beyond the control of the JPSL and/or the Jio Payments Bank and/or beneficiary bank.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bm97k',
      text: 'JPSL shall be entitled to charge such fees, charges and applicable taxes as it determines to be adequate for the provision of the UPI and as specified on the Platform or as communicated to the Consumer time to time or as per the JPSL Policy. The Merchant Partner acknowledges and understand that the completion of the transaction for the transfer of funds based on the Merchant Partner’s instructions shall involve various counter parties. The Merchant Partner confirms that the Bank/JPSL shall not be held liable or responsible for any delays/deficiencies in settlement of a transaction due to system constraints, actions of other parties or any other circumstances beyond the control of the JPSL/Bank. Without prejudice to the generality of the forgoing the Merchant Partner agrees and accepts its responsibility to compensate/reimburse the JPSL and the Bank for any losses, claims, or actions and to save, keep harmless and keep protected the JPSL and the Bank against any improper fraudulent instructions purporting to the received from the Merchant Partner and/or for furnishing incomplete information.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ejou3',
      text: 'The Merchant Partner understand that the provision of the UPI is subject to the guidelines and regulations issued from the time to time by the RBI/NPCI in this behalf. The RBI/NPCI and/or any other agency/company appointed by the RBI/NPCI in this regard shall be an intermediary/service provider in the process of the settlement of a transaction initiated using any of the UPI and subject to the availability of the sufficient funds in the Account. UPI transactions shall be deemed to be settled at the time when account of payer has been debited and account of the beneficiary has been credited in the central clearing system.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'eg3cd',
      text: 'JPSL and/or Bank may in its discretion deny any split payments.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '8omlj', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'f6dk3',
      text: 'INSPECTION AND INSTALLATION',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 27, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ai701',
      text: 'JPSL or transaction governing authority or Acquirer or Payment Service Provider or any legal/regulatory authority may carry out audit or inspection at the Merchant Partner Platform for the purpose of this Agreement i.e. in case of any audit directed by RBI or any such regulatory authority or if there is any fraud or suspicious transaction or similar transactions etc. In case of such audit or inspection the Merchant Partner shall provide necessary information, documents, papers as may be requested in relation to this Agreement and provide access to its premises to the authorised representative of JPSL and/or transaction governing authority to regulatory/legal authority, acquirer, Payment Service Provider as the case may be for such audit.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9smef',
      text: 'The Merchant Partner hereby authorises JPSL to share information/documents obtained from/about the Merchant Partner including KYC information to, (i) the credit rating organisation/verification agencies at the discretion of JPSL to verify Merchant Partner s’ credit rating/verify Merchant Partner’s credentials for the Merchant Partner Account activation at the cost of JPSL and/or, (ii) regulators, payment networks/schemes, as well as JPSL’s card acquiring service providers and ( c) Payment Service Providers. The Merchant Partner agrees that it shall have no objection if such verification agencies conduct verification of the Merchant Partner and hereby give express consent for the same and if the Payment Service Providers uses such information and documents for providing services to the Merchant Partner/Consumer.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a49fu',
      text: 'Any decision taken by JPSL about the Merchant Partner Account activation shall be considered as final.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'av9bs',
      text: 'The Merchant Partner shall be solely responsible for the upkeep, service and proper functioning of its POS. Merchant Partner is solely liable and responsible for any transaction on its POS, theft or damage of the POS or any other device used by the Merchant Partner for the transaction under this Agreement & the Merchant Partner agrees to indemnify and keep JPSL indemnified from any loss, cost, compensation, litigation, damages etc. arising out of and related to the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '9ttrc', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'ekrgj',
      text: 'TERM OF THE AGREEMENT',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 21, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '6r31m',
      text: 'This Agreement is effective from the date of execution by both the Parties and shall remain valid until terminated in accordance with the terms of this Agreement.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'dkil3', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'blsaf',
      text: 'JPSL’S ROLE AND RESPONSIBILITES',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 31, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '6d6du',
      text: 'JPSL’s role shall be limited to facilitating the Payment Mechanism between the Consumer and the Merchant Partner subject to terms of this Agreement.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'd8hp0',
      text: 'The right to accept or cancel a Transaction after the same has been initiated by the Consumer through the Payment Mechanism on the Merchant Partner Platform shall vest with the Merchant Partner. However, in the event a Transaction is cancelled, the Merchant Partner shall be under an obligation to refund the amount of such Transaction in accordance with terms of this Agreement, to the Consumer’s Payment Instrument used by the Consumer while making payment through the Payment Mechanism.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6a8bt',
      text: 'Notwithstanding anything to the contrary contained in this Agreement, JPSL shall have a right to restrict or prohibit a Transaction, without any liability to the Merchant Partner and the Consumer at its sole discretion if such Transaction is in breach or likely to breach of applicable laws, appears to JPSL to be fraudulent/suspicious.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '85o9a',
      text: 'JPSL shall not be liable to the Merchant Partner on account of any Consumer or the Merchant Partner being unable to access the Payment Mechanism due to any reason whatsoever including planned and unplanned maintenance activity, technical issues, Force Majeure etc. JPSL will endeavour to notify Merchant Partner in case of any planned maintenance activity.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bmu8m',
      text: 'JPSL shall time to time notify specific technical and business procedures and policies to be followed for optimal use of the Payment Mechanism.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '6964o', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '3nv6g',
      text: 'RESTRICTED USE',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 14, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '8oml2',
      text: 'The Merchant Partner shall not act as a payment intermediary, aggregator or service bureau or otherwise resell the Payment Mechanism on behalf of any third party including handling, processing or transmitting funds for any third party. The Merchant Partner also shall not use the Payment Mechanism to process cash advances.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'a5ned', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'ac66i',
      text: 'UNAUTHORIZED OR ILLEGAL USE',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 27, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '4pd5c',
      text: 'The Parties hereby agree that JPSL is under no obligation to authorize or settle any Transaction that is in violation of any agreement and applicable regulations or exposes other Consumers, JPSL’s process or incurs harm to JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9ot46',
      text: 'If JPSL reasonably suspects that Merchant Partner Account/Settlement Account has been used for an unauthorized, illegal, or criminal purpose, JPSL shall be free to share information about the Merchant Partner, Merchant Partner Account, Settlement Account, Merchant Partner’s Transactions and/or any other information and documents in relation to the Merchant Partner with the relevant regulators and legal authorities.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3qsef',
      text: 'Merchant Partner hereby agrees and grants express authorization to JPSL to share such information and documents to the relevant regulators/legal authorities under the circumstances as specified in Clause 11.2 above. It is further clarified, for the avoidance of doubt that any sharing of information under Clause 11.2 of the Agreement shall not be considered as a breach of any confidentiality obligation of JPSL under the Agreement.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'ulpl', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '9ooke',
      text: 'FEES',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 4, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '1gh6p',
      text: 'The Merchant Partner shall pay to JPSL the fees as agreed in MAF or by execution of separate mutually agreed document in writing or as published on the online Merchant Partner Account of the Merchant Partner which is accessible to the Merchant Partner after login to the JPSL website or as published by JPSL on Platform. The fee will be levied to the Merchant Partner during the clearing cycle by the Merchant Acquiring System (MAS) based on the MDR / Fee configured. The Parties agree that any changes in fees or other charges shall be as communicated by JPSL from time to time to the Merchant Partner vide letter correspondence or email or by publishing in the Merchant Partner Account of the Merchant Partner or on Platform. Continue use of the services by the Merchant Partner shall be treated as Merchant Partner’s acceptance of fees and other charges and/or any changes thereto.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '26tjp', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'epvkm',
      text: 'SETTLEMENT INTO ACCOUNT',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 23, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '9qgt',
      text: 'The payments (in respect of the successful Transactions) shall be managed and processed and paid to the Merchant Partner’s Settlement Account by JPSL from the Nodal Account in accordance with Applicable Laws. The payment schedule may be altered by JPSL any time with due intimation. However JPSL shall not intimate Merchant Partner if such schedule is changed as per the regulatory requirement. JPSL will make payments to the designated Settlement Account of the amounts actually received by JPSL in the Nodal Account for Transactions from the Consumer submitted through the Payment Mechanism (less any applicable fees & taxes, penalties etc., which JPSL may deduct prior to any payment being made to the Settlement Account). Funds for any given Transaction will not be deposited in the Settlement Account until the Transaction is deemed complete and successful at the sole satisfaction of JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1a5cp',
      text: 'The Merchant Partner shall monitor and communicate all errors in any of the settlements/monies processed and managed by JPSL (mentioned in Clause 13.1 above) to JPSL within thirty (30) calendar days of such settlement. Any additional or lesser amount paid to the Merchant Partner by JPSL shall be settled in the next settlement cycle. The Merchant Partner hereby agrees that JPSL shall have all the rights to recover/demand/set-off any additional amounts paid to the Merchant Partner from or against any other Transaction/monies payable by JPSL to the Merchant Partner. Further, JPSL may, in its sole discretion, seek refund of any such additional amount paid to the Merchant Partner and Merchant Partner shall refund such amount to JPSL within 2 days of receipt of such demand/communication to this effect. Failure to notify JPSL of any lesser amount paid to the Merchant Partner within 30 (thirty) calendar days will be deemed as a waiver of any right to amounts owed to the Merchant Partner.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cm3e0',
      text: 'SETTLEMENT ACCOUNT TERMS',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cj8t1',
      text: 'The Merchant Partner shall provide the details of its bank account with any bank at its discretion to JPSL for making it as a settlement account (“secondary account”) for settlement of the funds for the Transactions as per the Merchant Partner Account. The said secondary account shall be registered by JPSL as a settlement account and the funds payable to the Merchant Partner from the Escrow Account shall be settled in the said secondary account.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9j278',
      text: 'The Merchant Partner hereby gives express consent to JPSL to share the secondary settlement account details with the Jio Payments Bank.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'bfi7d',
      text: 'The Merchant Partner agrees that following terms shall be applicable if the Merchant Partner has opted for the Jio Payments Bank current account as its settlement account (“primary account”)-',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '1oh5u',
      text: 'The Merchant Partner has authorised the Jio Payments Bank to share Merchant Partner’s primary account details with JPSL.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5vmpb',
      text: 'If the Merchant Partner has opted for the primary account as settlement account by communicating the same to JPSL, the Merchant Partner shall get an SMS from JPSL with confirmation that the Merchant Partner has opted for the current account with the Jio Payments Bank as its settlement account.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3tf40',
      text: 'JPSL shall treat the primary account as settlement account and settle the funds payable to the Merchant Partner from the Escrow Account into the primary account if the Merchant Partner has not raised any objection after within 3 days from the notification as mentioned in point (ii) above.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '7ellh',
      text: 'As per RBI regulations, the Merchant Partner cannot maintain more than Rs. 1 lac (Rs. One lac) in the current account with the Jio Payments Bank and hence the Merchant Partner shall ensure to give standing instructions to the Jio Payments Bank to transfer the amount over and above Rs. 1 lac (Rs. One lac) in the secondary bank account (as communicated by JPSL to the Jio Payments Bank under this clause 13.3.c) as and when the amount crosses the value of Rs. 1 lac in the primary account. The Merchant Partner agrees that it shall be bound by the terms and conditions of the Bank and RBI regulations in relation to the primary account.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'blujv',
      text: 'The Merchant Partner shall be solely responsible to ensure that the secondary account and the primary account belongs to the Merchant Partner and it shall have no objection if the funds are settled as set-out in Clause 13.3.c.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b68hq',
      text: 'The Merchant Partner agrees that the secondary account shall be a Settlement Account till the Merchant Partner opts for the primary account as a settlement account. Once the Merchant Partner opts for the primary account as settlement account and JPSL initiate settlement in the said primary account the primary account shall be treated as Settlement Account for the purpose of this Agreement.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ai66v',
      text: ' The Merchant Partner authorises JPSL to debit any of the Merchant Partner’s account held with any of JPSL’s group companies, and affiliates including the Payments Bank in case of excess settlement or credits not in line with the transactions in the Merchant Partner account or any other recovery arising out of debit entries in the Merchant Partner account. ',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '3f2og', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'd8f70',
      text: 'REFUNDS AND DISPUTE/CHARGEBACK',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 30, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '1p2ud',
      text: 'REFUND',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '2i9gk',
      text: 'Refund can be processed on Merchant Partner request with reference to original Transaction. On request of Merchant Partner JPSL shall process the refund of said amount which shall not exceed the original Transaction amount at any given point in time. JPSL shall recover the said amount from Merchant Partner’s settlement or any other payables under this Agreement. The said amount shall be credited to Consumer’s account from which the transition was initiated.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'utpq',
      text: 'If Consumer approaches JPSL for refund and/or cancellation of the Transaction, JPSL shall request the Merchant Partner to confirm as to if such Transaction amount can be refunded. On Merchant Partner’s instructions JPSL will process or reject the refund for the Transaction. For processing refund, the process suggested in Clause 14.1.a here above shall apply.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '89rdt',
      text: 'DISPUTE',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '104dr',
      text: 'If in case of the dispute/complaint/claim is raised by the Consumer in relations to the Transaction. JPSL shall withhold the transaction amount from the settlement amount or any other payable to the Merchant Partner. JPSL shall conduct preliminary investigation and request Merchant Partner to provide the evidences for the said dispute within 7days from the time of the request raised by JPSL. JPSL shall honour the dispute, in case a) if Merchant Partner fails to provide evidences to the satisfaction of JPSL or there is no response from the Merchant Partner within 7 days; b)or if the result of the investigation by JPSL is in favour of the Consumer.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cdpg0',
      text: 'The Merchant Partner agrees if there is no sufficient settlement or any other payable available with JPSL to process the Refund as set-out in Clause 14.1 and/or 14.2, JPSL shall have a right to claim such amount from the Merchant Partner, the Merchant Partner shall pay the said amount to JPSL within 5 (five) days from the date of said claim.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '3r08j',
      text: 'Any grievances which the Merchant Partner may have with respect to the Transaction or the Payment Mechanism could be shared by the Merchant Partner with the nodal officer of JPSL at nodal.officer@jiopay.in.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [{ offset: 182, length: 24, key: 2 }],
      data: {},
    },
    { key: '65kc5', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '2ut04',
      text: 'RIGHT TO WITHHOLD PAYMENT',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 25, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'dg7v2',
      text: 'JPSL shall be, in relation to a Transaction, entitled to withhold such amount for such period as may be detailed out in the Grievance Redressal Policy.. Notwithstanding anything contained herein, where JPSL has reason to believe that any Transaction is fraudulently incurred, JPSL shall be entitled to withhold payment in respect thereof provided such withholding shall be in accordance with the applicable law and statutory timelines. In the event that JPSL is required to conduct an investigation, resolve any pending dispute related to the Merchant Partner Account, Settlement Account as per the Grievance Redressal Policy or as required by law or under direction of any regulatory authority, JPSL may defer payout or restrict access to certain funds till the resolution of such investigation or as may be directed by the regulators. Such funds held back shall not accrue any interest. In aforesaid scenario the Merchant Partner will be given an opportunity to hear and the JPSL shall after hearing the Merchant Partner take necessary decisions at its end. The decision of JPSL shall be final and binding on Merchant Partner. It is clarified that the above right may also be exercised by the Acquirer for card transaction services in accordance with the applicable laws and the Merchant Partner agrees to abide by the decision of the Acquirer in this regard.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'b978', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'bbcra',
      text: 'DISCLOSURES AND NOTICES',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 23, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '15tmq',
      text: 'JPSL shall provide disclosures and notices required by law and other information about the Merchant Partner Account to the Merchant Partner electronically through email address registered with JPSL and if the email is not registered by the Merchant Partner with JPSL such notices shall be displayed on the Platform. Such disclosures and notices are considered received by the Merchant Partner within 24 hours of such posting on the Platform or sending of the email.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'crf8s', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'brhi8',
      text: 'COMPLIANCE WITH PAYMENT STANDARDS',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 33, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '84c6s',
      text: 'The Merchant Partner agrees that all the systems of the Merchant Partner shall be compliant with the applicable payment industry standards and Regulatory requirement as may apply to the Merchant Partner. Merchant Partner shall follow reasonable security practices in line with industry best practices and PCI DSS recommendation based on PCI DSS specified level as communicated by JPSL from time to time and/or as per policy of JPSL Merchant Partner shall permit JPSL and/or any regulatory body including payment networks/acquirer/Payment Service Provider to conduct an audit of the Merchant Partner systems in order to verify such compliance. In case of any security lapses, data leak etc. Merchant Partner shall report such incidence to JPSL within 2 (two) hrs of such breach. The Merchant Partner shall not save customer card and such related data. The Merchant understands that JPSL reserves the right to undertake the security audit of the Merchant Partner to check its compliance under the applicable laws, as and when required.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'cc3o4', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'bs64f',
      text: 'CONFIDENTIALILTY',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 16, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'fkpup',
      text: 'For purposes of this Agreement, "Confidential Information" means all data, information and other material whatsoever, including but not limited to any technical or business information disclosed by JPSL and/or its Representatives to Merchant Partner and/or its representatives. Confidential Information includes all notes, analyses, compilations, forecasts, studies, summaries, information memoranda, opinions and similar documentation that incorporate or are derived from the Confidential Information; the existence and terms of this Agreement, the business purpose, the fact that discussions or negotiations are taking place, or have taken place, between parties in relation to the business purpose and contents of any discussion between the parties and/or their respective representatives in relation to the business purpose. The Merchant Partner shall keep all Confidential Information confidential and shall not share such information with any third party. The Merchant Partner shall use the Confidential Information only for the purpose of this Agreement and return such information to JPSL immediately on demand by JPSL or on termination of this Agreement whichever is earlier.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '8114h', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '7mr3s',
      text: 'SUSPENSION OR TERMINATION BY JPSL',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 33, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'cuo9c',
      text: 'Either Party may terminate this Agreement by giving 30 (thirty) days’ notice to the other Party in writing without assigning any reason.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '62gkr',
      text: 'JPSL reserves the right to cease to provide Payment Mechanism and/or suspend the Payment Mechanism/Agreement and/or close the Merchant Partner Account, without giving any notice to Merchant Partner at its own option and/or as per the instructions of the Payment Service Providers (a) if the Merchant Partner has breached the terms of this Agreement or applicable laws or any payment network rules; (b) Merchant Partner’s failure or neglect to use the Payment Mechanism or Merchant Partner Account for a continuous period of 180 (one hundred eighty) days; (c) any person other than the Merchant Partner is attempting to access the Merchant Partner Account or attempts to hack the same; (d) if some person presents identical commercial credentials in attempts to open another Merchant Partner Account; (e) if JPSL is mandated to do so by the relevant regulators or to the extent the same is required to be done by reason of any payment network rules; (f) any Transaction with the Merchant Partner is for any reason unlawful, or unenforceable; (g) the transaction is suspicious/fraudulent; (h) if the Payment Service Provide asks for such suspension/termination etc.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b4134',
      text: 'If any Payment Service Provider terminates its services for JPSL for any reason whatsoever JPSL may terminate this Agreement with immediate effect.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '80gk8',
      text: 'The Parties agree and confirm that any termination or suspension of this Agreement does not relieve the Merchant Partner of any obligations to pay Fees or costs accrued till the date of termination and any other amounts owed to JPSL as provided in this Agreement.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8qg2p',
      text: 'On termination of this Agreement, the Merchant Partner agrees to return all assets, materials, Confidential Information including any properties belonging to JPSL and destroy or return the same at the option of the JPSL. The Merchant Partner agrees to provide JPSL with a written confirmation within fifteen (15) business days, confirming such return or destruction as the case may be.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'fop5e', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '4ofdg',
      text: '20. CONSEQUENCES OF TERMINATION',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 31, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '7ng5t',
      text: 'Upon termination of the Agreement, the Merchant Partner agrees: (a) that upon completion of the said notice period, the relevant Merchant Partner Account shall be closed. Upon closure of the Merchant Partner Account, any pending Transactions will be cancelled. Any funds that JPSL is holding in custody for the Merchant Partner at the time of closure, less any applicable Fees and penalties, will be paid out in accordance with the payout schedule, assuming all payout-related authentication requirements have been fulfilled and no investigation is pending at the time of Merchant Partner Account closure; (b) to continue to be bound by such provisions of this Agreement which survive by their nature; (c) to immediately stop using the Payment Mechanism; (d) that JPSL reserves the right to delete all of information of the Merchant Partner and related account data stored on JPSL’s servers including Merchant Partner Account; (e) that JPSL shall not be liable to the Merchant Partner or any third party for termination of access to the Payment Mechanism or for deletion of Merchant Partner’s information or related account data including Merchant Partner Account; (f) to provide all records, data, documents in its possession to JPSL; and (g) to return all assets, materials and destroy software at the option of JPSL belonging to JPSL; (h) JPSL shall disconnect any and all services, Payment Mechanism and Merchant Partner Account shall be closed by JPSL and the Merchant Partner shall not be entitled to access the said account from the date of such termination.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '4qhpi', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '6fgbg',
      text: '21. OWNERSHIP',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 13, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'fh9nr',
      text: 'The relationship between JPSL and the Merchant Partner is limited to a contractual relationship for the provision of Payment Mechanism and is not one of a principal and agent. For the sake of clarity the Parties agree that the relationship between the Merchant Partner and JPSL shall be on principal to principal basis. The Payment Mechanism is protected by trademarks, copyright, trade secret and other intellectual property laws. The Merchant Partner agrees and acknowledges that JPSL and/or its affiliates are and shall continue to be the owner and/or licensee as the case may be of all trademarks, copyrights, trade secrets and other intellectual property rights in the Payment Mechanism, Platform and the Merchant Partner agrees and undertakes not to claim any right over any such trademark, copyright, trade secrets and/or other intellectual property rights.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'bgfb2', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '4f4j',
      text: '22. INDEMNITY',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 13, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '5s0o7',
      text: 'The Merchant Partner shall indemnify, defend and hold harmless JPSL from and against any and all claims, costs, losses, damages, judgments, tax assessments, penalties, interest and expenses including without limitation attorneys’ fees arising out of any claim, action, audit, investigation, inquiry, or other proceeding instituted by any person or entity that arises out of or relates to or in connection with: (a) any actual or alleged breach of the Merchant Partner’s representations, warranties, or obligations set forth in this Agreement; (b) violation of any third-party right, including without limitation any right of privacy, publicity rights or intellectual property rights; (c) violation of any law, rule or regulation of India or any other country; (d) Consumer or any other party’s access and/or use of the Merchant Partner Account with the Merchant Partner’s unique username, password or other appropriate security code; and/or (e) Transaction between the Merchant Partner and Consumer or any sale or proposed sale of Products by a Merchant Partner to the Consumer at Merchant Partner Platform; (f) Wrongful or improper use of JPSL technologies; (g) any issues and/or disputes in relation to the Transactions; (h) any issues/disputes in relation to Transaction on the POS of Merchant Partner or Transaction through Merchant Partner Platform and Payment Mechanism; (i) any refunds; (j) chargeback/dispute as mentioned in Clause 14; (k) any issues/disputes including Consumer disputes in relation to the Meal Card payment, Products of the Merchant Partner, refund/chargeback on Meal Card and any other issues/disputes in relation to the Sodexo Card; (l) breach of confidentiality and intellectual property rights obligation of the Merchant Partner; (m) dispute/claims/proceedings brought against JPSL and/or Payment Service Provider in relation to the Products offered/sold by Merchant Partner to the Consumer; (n) any fines, penalties, or interest imposed directly or indirectly on JPSL on account of Merchant Partner or transaction conducted through Merchant Partner under this Agreement. The indemnities shall survive termination of this Agreement.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '8m9sm', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '9nme1',
      text: '23. REPRESENTATION AND WARRANTIES',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 33, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'f2snm',
      text: 'The Merchant Partner represents, undertakes and warrants to JPSL that: (a) any Transaction submitted will represent a bona fide sale or rendering of Products by the Merchant Partner; (b) any Transactions submitted will accurately describe the Products sold and delivered by Merchant Partner to a Consumer; (c) it shall fulfil all obligations to each Consumer for which a Transaction has been submitted and will resolve any Consumer dispute or complaint directly with the Consumer; (d) the Merchant Partner and all Transactions initiated by the Merchant Partner will comply with all national, state, and local laws, rules, and regulations applicable to the Merchant Partner and/or the business, including any applicable tax laws and regulations for availing the Payment Mechanism and shall continue to remain compliant with the same; (e) no Transaction submitted through the Payment Mechanism will represent a sale to any principal, partner, proprietor, or owner of the JPSL; (f) the Merchant Partner will not use the Payment Mechanism, directly or indirectly, for any fraudulent undertaking or in any manner so as to interfere with the operation of the Payment Mechanism; (g) use of the Payment Mechanism will be in compliance with this Agreement and the applicable laws; (h) it is legally authorized to carry on business and has all necessary permits and licenses to carry out its business; (i) It shall use Payment Mechanism, the Merchant Partner Account and the Settlement Account only in India; (j) it will not accept payments in the Merchant Partner Account/Settlement Account or use Payment Mechanism or receive payment through Payment Mechanism/Merchant Partner Platform from the Consumer in connection with any and all business activities that are: (i) listed as excluded/banned/illegal activities on the Platform, as updated from time to time; and/or (ii) which are illegal/not permitted as per any applicable laws. (k) it shall ensure to maintain and preserve records of Transactions as per applicable laws. (l) the services provided by Payment Service Providers to JPSL which is passed to the Merchant Partner or the Payment Mechanism can be in any event be brought to abrupt end in any event whatsoever by Payment Service Provider or JPSL for any reason whatsoever. JPSL’s sole obligation and Merchant Partners sole and exclusive remedy in the event of interruption of the Payment Mechanism or loss of use and/or access to JPSL Platform/Payment Mechanism shall be to use all reasonable endeavours to restore the services/Platform and/or access to Payment Mechanism as soon as reasonably possible.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: '6evrr', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '6n90m',
      text: '24. NO WARRANTIES',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 17, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '5q1df',
      text: 'The Payment Mechanism and Platform are provided on an “as is” and “as available” basis. Use of the Payment Mechanism and Platform are at the Merchant Partner’s own risk. To the maximum extent permitted by applicable law, the Platform and Payment Mechanism are provided without warranties of any kind, whether express or implied, including, but not limited to, implied warranties for a particular purpose, or non-infringement. No advice or information, whether oral or written, obtained by the Merchant Partner from JPSL or through the Payment Mechanism/Platform will create any warranty not expressly stated herein. Without limiting the foregoing, JPSL, its processors, its providers, its licensors (and their respective subsidiaries, affiliates, agents, directors, and employees) do not warrant that the content is correct; that the Payment Mechanism and Platform will meet the Merchant Partner’s requirements; that the Payment Mechanism and Platform will be available at any particular time or location, uninterrupted or secure; that any defects or errors will be corrected; or that the Payment Mechanism and Platform is free of viruses or other harmful components. Any content downloaded or otherwise obtained through the use of the Payment Mechanism and Platform is downloaded at the Merchant Partner’s own risk and he will be solely responsible for any damage to his property or loss of data that results from such download.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'bu8rj', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'e4jvj',
      text: 'JPSL does not warrant, endorse, guarantee, or assume responsibility for any product or service advertised or offered by a third party through the Payment Mechanism or Platform or any hyperlinked website or service, or featured in any banner or other advertising, and JPSL will not be a party to or in any way monitor any Transaction between the Merchant Partner, third-party providers of such products or services and the Consumer.',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'blj9o', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'dsok0',
      text: '25. LIMITATION OF LIABILITY AND DAMAGES',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 39, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'co2pt',
      text: 'JPSL, nor its affiliates nor any of their respective directors, officers, employees or agents shall be liable for any losses or damages resulting from the hacking, tampering or other unauthorized access or use of JPSL technologies, Merchant Partner Account, Settlement Account or the Payment Mechanism or Platform or the information contained therein or any claims from any Consumer purchasing or proposed to purchase any Products from the Merchant Partner.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '8v2u9',
      text: 'In the event that any Party breaches this Agreement, in addition to any other remedies provided pursuant to this Agreement or applicable law, the non-breaching Party will be entitled to recover from the breaching Party only the actual and direct damages that the non-breaching Party incurs on account of such breach. Notwithstanding any other provision of this Agreement, in no event, either Party, a Party’s direct or indirect subsidiaries, affiliates, agents, employees or representatives be liable for (i) any indirect, incidental, special, punitive, exemplary or consequential damages of any kind in connection with or arising out of this Agreement, or (ii) any lost profits, any loss of revenue or any compensation for anticipated sales or the cost of procurement of substitute services or for any costs, expenses, expenditures, investments or other commitments made in reliance upon or otherwise in connection with or arising out of this Agreement, under statute, in equity, at law or otherwise, whether or not the Party has been advised of the possibility of such damage.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9cjaf',
      text: 'The total liability of JPSL under this Agreement shall not be more than Rs. 1000/- (Rs. One thousand only).',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'c9svs', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'dvg3s',
      text: '26. MERCHANT’S TERMS AND ACCEPTANCE',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 35, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '9cjad',
      text: 'The Service Provider is inter alia engaged in the business of offering e-commerce services which include bill presentments / payment and accepting instructions through the internet in respect of payments to be made by the Customers using valid Payment Instruments to purchase/ avail various Products and Services offered by Merchant and accordingly transfer funds from the Customer’s bank account to the Merchant’s bank account. The Service Provider act as an authorised Payment Aggregator that facilitate e-commerce sites and Merchants to accept various Payment Instruments from the Customers for completion of their payment obligations in accordance with RBI Guideline bearing No.- RBI/DPSS/2019-20/174 DPSS.CO.PD.No.1810/02.14.008/2019-20 dated March 17,2020 titled “Guidelines on Regulation of Payment Aggregators and Payment Gateways” (hereinafter referred to as the said “RBI Guideline”).',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4cjad',
      text: 'The Merchant undertakes to be abided by the rules and regulations formed by the governing authority in respect of the Anti-Money Laundering Act 2002, Information Technology Act 2000 and subsequent amendments incorporated thereon and guidelines issued by the Department of Regulation, RBI from time to time for Combating Financing of Terrorism (CFT).',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5cjad',
      text: 'The Merchant hereby undertakes that, all the representations made herein are true and valid as per law of India. The Merchant represents that the Merchant holds valid licenses, brand proofs, tie-up agreements from its business associates and the Merchant is legally authorised to sale the Products and Services online through the Merchant’s Site.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5cjbd',
      text: 'The Merchant shall provide supporting documents to the Service Provider at the time of execution of this Agreement and upon change in details provided under this Agreement. The Merchant shall provide the KYC documents to Service Provider as requested.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5bjbd',
      text: 'The Merchant shall keep updated on its Site all the policies including but not limited to privacy policy, refund and return policies, Chargeback policy (I accept policy), Customer grievance redressal (including turnaround time for resolving queries), and other terms and conditions pertaining to the Products and Services of the Merchant. The merchant provides a copy of these documents as and when requested by the Service provider.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'c9sva', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'dvg3h',
      text: '27. DATA PROTECTION',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 19, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '9cjar',
      text: 'All the data processed under this Agreement is subject to the Data Privacy Regulations under Applicable Law. Merchant and Service Provider shall be subject to and will comply with the Information Technology Act, 2000 and the Information Technology (Reasonable Security Practices and Procedures and Sensitive Personal Data or Information) Rules, 2011 and any other Applicable Law restricting collection, use, disclosure, storage, processing and free movement of personal information (collectively, the “Privacy Regulations”).',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '4chad',
      text: 'Service Provider its employees, contractors or agents may, in connection with this Agreement, collect Personal Information in relation to Merchant (including Merchant Customers, employees and directors) Service Provider may process, use and disclose, transfer and store the Merchant’s Customer’s personal information for purposes connected with this Agreement and otherwise for the purposes of its legitimate business and business operations or as required by law. The Merchant shall co-operate with the Service Provider and Facility Providers in respect of any issues arising out of a breach or potential breach of security in relation to the holding of confidential data.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5bjad',
      text: 'Insofar as information provided, or to be provided, by Merchant to Service Provider includes the Personal Information of Customers, Merchant represents and warrants that it has obtained sufficient informed prior consent in writing from each Customer to whom any Personal Information relates to, in order for Service Provider to comply with Applicable Law and which allows Service Provider to collect, use, disclose, process transfer and store such information for the purposes specified in this Agreement and the schedules, including in the circumstances described above, and will provide Service Provider with such consent as and when requested by Service Provider.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'c9sdd', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: 'dvg2h',
      text: '28. MISCELLANEOUS',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 17, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '43g04',
      text: 'GOVERNING LAW AND DISPUTES This Agreement shall be governed by the laws of India. The courts in Mumbai shall have exclusive jurisdiction. Any Dispute arising out of or in connection with the Agreement shall be amicably settled at the first instance by mutual discussions and negotiations. In the event the dispute is not resolved within 30 (thirty) days then any Party may refer the same to the arbitration of single arbitrator to be appointed mutually by the Parties. The provisions of the Arbitration and Conciliation Act, 1996 shall be applicable to such arbitration or any enactment of statutory modification thereof. The arbitration proceedings shall be in the English language. The place of arbitration shall be Mumbai. The award of the arbitral tribunal shall be final and binding upon the Parties and no appeal against the same shall lie to any court. Notwithstanding the foregoing, either Party may bring an action before the courts in Mumbai of appropriate jurisdiction for interim injunctive relief. Merchant Partner agrees and acknowledges that JPSL shall not be made party to any dispute with Consumer/card holder/any other consumer which is in connection with/over Products offered/sold by the Merchant Partner and the Merchant Partner agrees to indemnify JPSL from any loss, cost, compensation etc. arising out of the same and out of disputes with the Consumer.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 26, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '7m9s3',
      text: 'RIGHT TO AMEND These terms and conditions/Agreement may be amended by JPSL by publishing the revised Agreement, amendments, modifications, additions to the Agreement on the Platform of JPSL or by communicating the same to the Merchant Partner through email or letter correspondence. Continued use of the Payment Mechanism by Merchant Partner shall be treated as acceptance of the revised Agreement/amendments/modifications to terms by the Merchant Partner.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 14, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '9o7or',
      text: 'ASSIGNMENT JPSL may assign this Agreement to third parties without giving any notice and assigning any reason to the Merchant Partner whereas Merchant Partner may assign this Agreement by giving 30 days’ notice to JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 10, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '940o0',
      text: 'OTHER PROVISIONS The Agreement does not limit any rights that JPSL may have under trade secret, copyright, patent, or other laws. JPSL’s failure to assert any right or provision under this Agreement shall not constitute a waiver of such right or provision. No waiver of any term in this Agreement shall be deemed as a further or continuing waiver of such term or any other term.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 16, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '5t634',
      text: 'NON EXCLUSIVITY Nothing in this Agreement shall prohibit JPSL from providing services similar to those provided under this Agreement to other Merchant Partner/merchant including but not limited to competitors of the Merchant Partner.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 15, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '4p1st',
      text: 'FORCE MAJEURE Notwithstanding the provisions of this Agreement, Merchant Partner shall not be eligible for liquidated damages, damages or any cost or termination for default against JPSL, if and to the extent that the delay in performance or other failure to perform its obligations under the contract is the result of an event of Force Majeure. If a Force Majeure situation arises, JPSL shall as soon as reasonably possible notify the Merchant Partner in writing of such conditions and the cause thereof. Unless otherwise directed by the Merchant Partner in writing, JPSL shall continue to perform its obligations under the Agreement as far as reasonably practical, and shall seek all reasonable alternative means for performance not prevented by the Force Majeure event. Either Party may terminate this contract, by giving a written notice of minimum 30 days to other Party, if as a result of Force Majeure, JPSL being unable to perform a material portion of the services for a period of more than two months.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 13, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '30dvd',
      text: 'This Agreement constitutes the entire agreement between JPSL and the Merchant Partner pertaining to the subject matter hereof and supersedes in their entirety all written or oral agreements between the Parties.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b0jsk',
      text: 'The Parties to this Agreement are independent contractors and nothing in this Agreement will make the parties joint ventures, partners, employees, agents etc. of the other party.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b95g6',
      text: 'JPSL may amend this Agreement any time. Such amendment or variations shall be effective and binding on the Merchant Partner on its publication on the JPSL platform. The Merchant Partner shall visit JPSL Platform and keep itself updated to any changes and amendments. If Merchant Partner is not willing to accept the said amendment/modifications it shall notify the same to JPSL in writing within 5 days from the date such changes are published on the JPSL Platform.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5rc04',
      text: 'SEVERABILITY Where any particular term or provision of this Agreement is determined under applicable law to be un-enforceable, such un-enforceable term(s) shall be severed from and will not affect any other terms and conditions. JPSL reserves the right to substitute any such un-enforceable term or provision with a suitable and enforceable provision at its sole discretion.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 12, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '447hu',
      text: 'CHANGES TO THE JPSL POLICY AND TERMS AND CONDITION. The Merchant Partner agrees that it shall be bound by the JPSL Policy(s) and terms and conditions published on the Platform from time to time. The Merchant Partner shall frequently check the Platform for any changes in JPSL Policy and terms and conditions to stay informed. The Merchant Partner acknowledges and agree that it is their responsibility to review JPSL Policy and terms and conditions periodically and become aware of modifications.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    { key: 'bongp', text: '', type: 'unstyled', depth: 0, inlineStyleRanges: [], entityRanges: [], data: {} },
    {
      key: '7fcm',
      text: '29. VOICEBOX TERMS',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 18, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '6s6jf',
      text: 'The Merchant Partner understands that to ensure network connectivity for smooth Service(s) of the VoiceBox, JPSL has procured SIM cards from telecom service providers and assembled the same in the VoiceBox. In this regards the Merchant Partner undertakes and agrees to use the VoiceBox exclusively at the Merchant Partner’s premises/location and for the purposes stated in the Agreement, in compliance with all Applicable Law.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b1hac',
      text: 'The Merchant Partner hereby acknowledges, agrees and confirms that the VoiceBox, the SIM Card remains the exclusive property of JPSL and provided to the Merchant Partner on lease as a service on subscription model. The Merchant Party shall surrender the VoiceBox on demand during the term of this Agreement and immediately upon any termination of this Agreement in working condition. Under no circumstances shall the Merchant claim any right, title or interest in or to the VoiceBox for any reason whatsoever. ',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9vo83',
      text: 'The Merchant Partner agrees that the Merchant Partner details may be shared with telecom service providers and/or other regulators, if required for the purposes of availing such services.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ets46',
      text: 'The Merchant Partner agrees and undertakes that it shall not remove the SIM Card from the VoiceBox under any circumstance.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5fa8f',
      text: 'The Merchant Partner shall be responsible for the safekeeping/maintenance of the VoiceBox and all other devices or items deployed or provided by JPSL and for the secrecy of any software and keys (embedded into the VoiceBox), if any and shall neither allow or facilitate any piracy, nor violate any copyright/ trademark relating to any software or other intellectual property rights. ',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a3im3',
      text: 'This Warranty of the VoiceBox excluding battery, charger, and USB cable, extends for a period of 12 months commencing from the date of the activation / date of payment of setup fee by the Merchant (“Warranty Period”). The Warranty of the charger, battery and USB cable extends for a period of 6 months commencing from the date of activation/ date of payment of setup fee by the Merchant. ',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b1had',
      text: 'During the Warranty Period, the Merchant Partner shall request for return or replacement via JioPay Business app or by contacting customer support via email. JPSL shall repair or replace the VoiceBox or any relevant parts thereof in the event that the VoiceBox is found to be defective without cost to the Merchant Partner during the Warranty Period. Provided that, in case the VoiceBox is damaged due to Merchant Partner’s fault, charges against such damaged VoiceBox shall be deducted from Merchant Partner payout.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9vo85',
      text: 'The Merchant Partner shall also be bound by the Limited Warranty Terms and Conditions mentioned on the warranty card.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ets47',
      text: 'The Merchant Partner shall not: ',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5fa8w',
      text: 'Sell, assign, transfer, lease or otherwise dispose of any VoiceBox deployed or provided by JPSL;',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5fa8t',
      text: 'Remove, conceal or alter any markings, tags or dates attached to VoiceBox or any part thereof indicating JPSL’s ownership of such VoiceBox.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5fa8u',
      text: 'Permit any third party to perform the maintenance services on the VoiceBox deployed or provided by JPSL or effect modifications, enhancement or software/engineering changes to the VoiceBox or any other device deployed or provided by SBIP, without the prior written consent of SBIP or its authorization to its representatives.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5fa8vv',
      text: 'Alter or modify the programme in the VoiceBox.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5fa7s',
      text: 'The Merchant Partner must inform JPSL of any loss of or damage to any SIM Card and/or VoiceBox or upon becoming aware that any party is making improper use of same. The Merchant Partner will be responsible for any charges incurred as a result of any unauthorised use of the SIM Card/ VoiceBox until such time as it has notified JPSL. In such an event, Merchant Partner understands that JPSL shall have to inform about the same to the telecom service providers and other regulators / authorities / law enforcement agencies.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a3im4',
      text: 'Merchant Partner further agree and undertakes to be responsible/liable for any costs/damages/losses incurred by JPSL due to Merchant Partner’s unauthorized/illegal use of VoiceBox or the SIM card fitted in such device, and/or any physical damage caused to the VoiceBox. In event of breach of this clause by Merchant Partner, JPSL shall have the right to terminate the agreement and take such appropriate action as it may deem fit, including but not limited to blacklisting and reporting of Merchant Partner to appropriate government authorities and immediate disabling or suspension of the SIM Card.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a3in4',
      text: 'Merchant Partner agrees that the SIM card/data shall not be used to make any foul or profane expressions, impersonate another person with fraudulent or malicious intent, for any improper, immoral, anti-national, unlawful, or abusive purpose or for sending obscene, indecent, threatening, harassing, unsolicited messages, to call another person so frequently or at such times of the day or any other manner so as to annoy, abuse, threaten or harass to any other person whomsoever.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a4inr',
      text: 'The Merchant Partner  shall indemnify and hold harmless JPSL from all suits, costs, damages or claims of any kind arising out of any act or omission or misuse of the SIM card  by the Merchant Partner or any other person with or without the consent of the JPSL or suffered as a result of any use of the SIM Card which is not in accordance with these terms and/or the provisions of any telecom tervice providers, or other laws, which are applicable to the SIM Card.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a4idr',
      text: 'The Merchant Partner shall be liable to pay fees for using the VoiceBox as agreed by the Merchant with JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'f4h6h',
      text: 'Other Terms and Conditions',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 26, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a4idp',
      text: 'Please note that the fee is subject to change and JPSL reserves the right to modify the pricing model at any time in the future. Any changes to the pricing model will be communicated to the Merchant Partner in advance.',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a4ipe',
      text: 'Failure on the part of the Merchant Partner to make the Subscription fee or any other charges (if applicable) shall result in:',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a4ips',
      text: 'Late payment fees, penalties, interests, and/or any other charges as may be raised by JPSL;',
      type: 'ordered-list-item',
      depth: 1,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a4iph',
      text: 'Netting/set off by JPSL of any and all amounts of the Merchant Partner which are accessible to JPSL including from the Nodal/Escrow Bank Account, the initiation of appropriate legal proceedings against Merchant Partner for recovery of its dues, deactivation of the VoiceBox and/or blacklisting of Merchant Partner;',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a4ipx',
      text: 'Repossession of VoiceBox by the Merchant Partner or deactivation of VoiceBox, if the VoiceBox remains inactive for a continuous period of 03 month or if Merchant Partner does not pay the monthly rental cost of the VoiceBox Device  for a continuous period of 3 months.',
      type: 'ordered-list-item',
      depth: 2,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'dc2c7',
      text: '30.  Low KYC/P2PM Merchant',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 26, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: 'e42jq',
      text: 'JPSL shall classify a Merchant as P2PM Merchant based on the transaction value that has been facilitated for such Merchant.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ebfb8',
      text: 'In the event of JPSL reclassifying the P2PM Merchant due to an increase in transaction value, it shall notify the P2PM Merchant of change in classification through the Platform or any other mode determined by JPSL. If such reclassification occurs, JPSL may request additional KYC documents from the P2PM Merchant.  The P2PM Merchant is obligated to provide the requested information within the time period specified by JPSL.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b9k7f',
      text: 'If the P2PM Merchant is unable to provide additional KYC documents, JPSL reserves the right to reject or hold the transactions.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '7fcl',
      text: '31. DECLARATION',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [{ offset: 0, length: 15, style: 'BOLD' }],
      entityRanges: [],
      data: {},
    },
    {
      key: '3kij6',
      text: 'The person accepting/executing/signing these terms and conditions on behalf of Merchant Partner (“Authorised Person”) agrees and declares as under:',
      type: 'unstyled',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '6s6je',
      text: 'Authorised Person agrees and confirms that the Authorised Person is duly authorised representative of the Merchant Partner and signing on behalf of the Merchant Partner:',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'b1hab',
      text: 'Authorised Person is legally empowered by and duly authorised as the Authorised Person, to accept these Merchant Partner terms and conditions.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '9vo82',
      text: 'The Merchant Partner is duly authorised under law to undertake all activities and assume all duties, responsibilities and obligations as Merchant Partner.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'ets45',
      text: 'The digital copy of the proof documents, furnished by me and/or enclosed herewith, for establishing Merchant Partner identity, address and business (and which may include, for the purposes of establishing proof of bona fide business of Merchant Partner, the latest invoices placed on Merchant Partner by the supplier establishment recognized by JPSL) are true, complete and accurate in all respects.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: '5fa8g',
      text: 'To the extent that any of the proof documents furnished require renewals and/or re-authentication/attestation or where any further documents become necessary for submission, the Merchant Partner assumes complete responsibility for obtaining and submitting the same.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
    {
      key: 'a3im2',
      text: 'In case, any of the above information or documents are found to be insufficient, false, untrue, misleading and/or misrepresenting, the Merchant Partner assumes sole responsibility and liability for any and all ensuing consequences.',
      type: 'ordered-list-item',
      depth: 0,
      inlineStyleRanges: [],
      entityRanges: [],
      data: {},
    },
  ],
  entityMap: {
    '0': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'https://jiopay.in/business' } },
    '1': {
      type: 'LINK',
      mutability: 'MUTABLE',
      data: {
        url: 'https://www.jiopaymentsbank.com/docs/t&c_languages/t-n-c-jul21/jpb-terms-and-conditions-020721.pdf#page=1',
      },
    },
    '2': { type: 'LINK', mutability: 'MUTABLE', data: { url: 'mailto:nodal.officer@jiopay.in' } },
  },
}
